import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'altCheck'
})
export class AltCheckPipe implements PipeTransform {

  transform(value: string): { textWithoutAlt: string; altText: string | null } {
    const altTagRegex = /<alt>(.*?)<\/alt>/;
    return {
      textWithoutAlt: value?.replace(altTagRegex, '').trim() || '',
      altText: value?.match(altTagRegex)?.[1] || null
    };
  }

}
